export default {
  catalog: {
    menu: {
      catalog: 'Catalog',
    },
    breadcrumbs: {
      catalog: 'Catalog',
      search: 'Search',
    },
    entity: {
      name: 'Item name',
      description: 'Item Description',
      sku: 'SKU',
      code: 'Code',
      manufacturer: 'Manufacturer',
      manufacturer_partnumber: 'Part Number',
      uom: 'UOM',
      price: 'Unit Price',
      class: 'Category',
      colloquial: 'Colloquial',
      keywords: 'Keywords',
      currency: 'Currency',
      category: 'Class',
      noun: 'Element Name',
      modifier: 'Modifier',
      has_stock: 'Stock',
      is_obsolete: 'Obsolete Item',
      is_active: 'Active Item',
      technical_specification: 'Description',
      updated_at: 'Last Update',
      equivalences: 'Equivalences',
    },
    pages: {
      '_admin-manage-products': {
        title: 'Item manager',
        actions: {
          create: {
            title: 'Create Item',
            help: 'Option to create a new item in the catalog',
          },
        },
      },
      '_admin-manage-product': {
        title: 'Manage item',
        validation: {
          message: 'You have required fields without completing',
        },
        entity: {
          help: {
            name: 'This is a short description that does not contain the entire specification of the item, but allows us to understand in some detail what type of item it is.',
            description: 'In this field you must add all the details of the description, including all the technical specifications that you have available.',
            price: 'This value corresponds to the list or reference price.',
            modifier: 'It is the most relevant characteristic of the item. Ex: BALL (in BALL BEARING), ELECTRIC (in ELECTRIC MOTOR), HYDRAULIC (in HYDRAULIC PUMP).',
          },
        },
        actions: {
          add_equivalences: 'Add Equivalence',
          download: 'Download',
          remove: 'Remove',
          publish: 'Publish',
          see: 'See file',
          restore: 'Restore',
          save_changes: 'Save Changes',
          create_new: 'Create Request',
        },
      },
      search: {
        title: 'Item search',
        placeholders: {
          searchBy: 'Search by keywords',
        },
        filters: {
          status: {
            title: 'Item Status',
            options: {
              all: 'Everyone',
              published_at_is_not_null: 'Only published items',
              published_at_is_null: 'Only unpublished items',
            },
          },
          price: {
            title: 'Item Price',
            options: {
              all: 'Everyone',
              price_gte_1_lte_null: 'Only items with a price greater than 0',
              price_gte_0_lte_0: 'Only items with price 0',
            },
          },
          unpublished: 'Unpublished',
        },
        actions: {
          search: 'Search',
          edit: 'Edit',
        },
      },
      product: {
        title: 'Item',
        tabs: {
          attributes: 'Attributes',
          manufacturer: 'Manufacturer (materials)',
          classification: 'Classification',
          attachment: 'Attachments',
          general: 'General information',
          stock: 'Stock Detail',
          technical_specification: 'Additional Information',
          equivalences: 'Equivalent Items',
        },
        tables: {
          attributes: {
            headers: {
              position: 'Position',
              attribute: 'Attributes',
              value: 'Value',
            },
          },
          attachment: {
            headers: {
              filename: 'Document Name',
              action: 'Action',
            },
          },
          stock: {
            headers: {
              quantity: 'Quantity',
              uom: 'UOM',
              country: 'Country',
              city: 'City',
            },
          },
          technical_specification: {
            headers: {
              title: 'Specification',
            },
          },
        },
        actions: {
          catalog: 'Go to catalog',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/catalog.js